import { combineReducers } from 'redux';
import { templates } from './redux/reducers/templates';
import { templateCard } from './redux/reducers/templateCard';

export const Templates = combineReducers({
  Templates: templates,
  TemplateCard: templateCard,
});
